// import { useMemo } from 'react';
import MidiWriter from 'midi-writer-js';

function GenerateMIDIFile({sequence, beatSize, index}) {
    const keys = [ 'C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B' ];
    function midiData (sequence) {
        // Start with a new track
        const track = new MidiWriter.Track();

        // Convert sequence to MIDI
        let currentTime = 0;
        sequence.forEach((midiEvent) => {
            if (midiEvent.constructor.name === 'Note') {
                const currentNote = new MidiWriter.NoteEvent(
                    {
                        pitch: (keys[midiEvent.value] + midiEvent.octave), 
                        tick: (currentTime), 
                        duration: ('T' + midiEvent.duration * 128 / beatSize),
                        velocity: midiEvent.velocity
                    });
                track.addEvent(currentNote);
            };
            currentTime += midiEvent.duration * 128 / beatSize;
        });

        // Generate a MIDI file
        const write = new MidiWriter.Writer([track]);
        return write.buildFile();
    };

    const midiArray = midiData(sequence.sequence);
    const blob = new Blob([midiArray], { type: 'audio/midi' });
    const fileUrl = URL.createObjectURL(blob);

    return <div className='midiFiles'>
        <a href={fileUrl} download={'MIDI File ' + (index + 1) + '.mid'}>
            <button>{'MIDI File ' + (index + 1) + '.mid'}</button>
        </a>
    </div>
};

export default GenerateMIDIFile